// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationComp_pagination__Oh5Ac","pageBtn":"PaginationComp_pageBtn__1cXNz","active":"PaginationComp_active__lTMR3","ellipsis":"PaginationComp_ellipsis__jRhfN"};